import { Components } from '@mui/material';

export const MuiMenu: Components['MuiMenu'] = {
  styleOverrides: {
    paper: {
      borderRadius: '0 !important',
    },
  },
};
